import React, { useState } from "react";
import { Loader2, Star } from "lucide-react";
import { toast } from "sonner";
import { Modal, reviewsApi, inputCls, btnCls, SOURCE_META } from "./shared";

const empty = { source: "gyg", reviewer_name: "", rating: 5, body: "", review_date: new Date().toISOString().slice(0, 10), booking_ref: "", source_url: "", title: "" };

export default function AddReviewModal({ open, onClose, onDone }) {
  const [f, setF] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.body.trim() && !f.rating) { toast.error("Yıldız veya yorum metni girin"); return; }
    setSaving(true);
    try {
      const res = await reviewsApi.create({ ...f, rating: Number(f.rating) || null });
      toast.success(res.matched ? "Yorum eklendi ve rezervasyonla eşleşti" : res.updated ? "Bu yorum zaten kayıtlıydı" : "Yorum eklendi (eşleşme bekliyor)");
      setF(empty); onDone();
    } catch (err) { toast.error(err?.response?.data?.detail || "Kaydedilemedi"); }
    setSaving(false);
  };

  return (
    <Modal open={open} onClose={onClose} title="Yorum Ekle" testId="add-review-modal">
      <form onSubmit={submit} className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-slate-400">Kaynak
            <select value={f.source} onChange={e => set("source", e.target.value)} className={`${inputCls} w-full mt-1`} data-testid="add-source">
              {Object.entries(SOURCE_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
            </select>
          </label>
          <label className="text-xs text-slate-400">Yorum Tarihi
            <input type="date" value={f.review_date} onChange={e => set("review_date", e.target.value)} className={`${inputCls} w-full mt-1`} data-testid="add-date" />
          </label>
          <label className="text-xs text-slate-400">Müşteri / Yorumcu Adı
            <input value={f.reviewer_name} onChange={e => set("reviewer_name", e.target.value)} className={`${inputCls} w-full mt-1`} data-testid="add-reviewer" />
          </label>
          <label className="text-xs text-slate-400">Booking Ref (Canlı Sayfa KOD)
            <input value={f.booking_ref} onChange={e => set("booking_ref", e.target.value.toUpperCase())} placeholder="GYG… / BR-…" className={`${inputCls} w-full mt-1 font-mono`} data-testid="add-ref" />
          </label>
        </div>
        <div className="text-xs text-slate-400">Yıldız
          <div className="flex items-center gap-1 mt-1" data-testid="add-rating">
            {[1, 2, 3, 4, 5].map(i => (
              <button type="button" key={i} onClick={() => set("rating", i)} className="p-0.5" data-testid={`add-rating-${i}`}>
                <Star className={`w-6 h-6 ${i <= f.rating ? "text-amber-400" : "text-slate-600"}`} fill={i <= f.rating ? "currentColor" : "none"} />
              </button>
            ))}
            <span className="text-slate-300 ml-2 text-sm">{f.rating}/5</span>
          </div>
        </div>
        <label className="text-xs text-slate-400 block">Başlık (opsiyonel)
          <input value={f.title} onChange={e => set("title", e.target.value)} className={`${inputCls} w-full mt-1`} data-testid="add-title" />
        </label>
        <label className="text-xs text-slate-400 block">Yorum Metni
          <textarea rows={4} value={f.body} onChange={e => set("body", e.target.value)} className={`${inputCls} w-full mt-1`} data-testid="add-body" />
        </label>
        <label className="text-xs text-slate-400 block">Kaynak Linki (opsiyonel)
          <input value={f.source_url} onChange={e => set("source_url", e.target.value)} placeholder="https://…" className={`${inputCls} w-full mt-1`} data-testid="add-url" />
        </label>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" onClick={onClose} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200`} data-testid="add-cancel-btn">Vazgeç</button>
          <button type="submit" disabled={saving} className={`${btnCls} bg-blue-600 hover:bg-blue-500 text-white`} data-testid="add-submit-btn">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Kaydet
          </button>
        </div>
      </form>
    </Modal>
  );
}
